import { TabsType, Weights, MapTypeIdsType } from './enums';
import strings from './language/Swedish';
import { ColumnEnum } from './enums';
const AUTH_COOKIE = 'authToken';
const REFRESH_COOKIE = 'refreshToken';
const ANALYTICS_ROLE = 'VALUATION_SERVICE2:SALES_REF_LIMIT_250';

const ReportItems = [
  {
    title: strings.navigation.sold,
    value: TabsType.sold,
  },
  {
    title: strings.navigation.ads,
    value: TabsType.ads,
  },
  {
    title: strings.navigation.market,
    value: TabsType.market,
  },
  {
    title: strings.navigation.priceDev,
    value: TabsType.priceDevelopment,
  },
];

const IGNORE_LIST_REPORT = [
  ColumnEnum.allabrfUrl,
  ColumnEnum.allabolagUrl,
  ColumnEnum.pdf,
  ColumnEnum.prospectUrl,
  ColumnEnum.housingAssociationReportYear
];

const MapTypeIds:{ label: string; value: string; }[] = [
  {
    label: strings.navigation.mapTypeNames.terrain,
    value: MapTypeIdsType.terrain
  },
  {
    label: strings.navigation.mapTypeNames.satellite,
    value: MapTypeIdsType.satellite
  },
  {
    label: strings.navigation.mapTypeNames.hybrid,
    value: MapTypeIdsType.hybrid
  },
  {
    label: strings.navigation.mapTypeNames.roadmap,
    value: MapTypeIdsType.roadmap
  }
] as const;

const LOADING_TYPE = {
  CLIENT: 'client',
  DEFAULT: 'default',
  EXPORT: 'export'
} as const;

const weightItems = [
  { value: Weights.none, label: strings.filter.none },
  { value: Weights.low, label: strings.filter.low },
  { value: Weights.medium, label: strings.filter.medium },
  { value: Weights.high, label: strings.filter.high },
];

const STYLED_STATE = {
  CLOOSED: "closed",
  ACTIVE: "active"
} as const;

const ROLE_TYPES = {
  MARKET_SHARE_AD: "VALUATION_SERVICE2:MARKET_SHARE_ADS",
  SALES_REF_LIMIT_250: "VALUATION_SERVICE2:SALES_REF_LIMIT_250",
  BASIC: "VALUATION_SERVICE2:BASIC"
} as const;


const SEARCH_TYPES  = {
  ADRESS: "Frisök",
  PROPERTY: "Fastighetsbeteckning"
} as const;

//Currently calculated double FIX THIS!
const DISTANCE_STEPS_SOLD = [250,1000,2500] as const;
const DISTANCE_STEPS_ADS = [500,1500,3000] as const;

export {
  AUTH_COOKIE,
  REFRESH_COOKIE,
  ReportItems,
  weightItems,
  ANALYTICS_ROLE,
  LOADING_TYPE,
  MapTypeIds,
  ROLE_TYPES,
  STYLED_STATE,
  DISTANCE_STEPS_SOLD,
  SEARCH_TYPES,
  DISTANCE_STEPS_ADS,
  IGNORE_LIST_REPORT
};
